/**
 * Copy DÙNG CHUNG của bản tiếng Anh — đối ứng từng khoá với `../vi/common.ts`.
 *
 * File này KHÔNG tự khai kiểu: chốt hình dạng nằm ở `./index.ts` (`export const en: Copy`), nơi
 * cả ba phần gộp lại. Khai `: Copy` ở đây thì mỗi phần lại đòi phủ trọn hình dạng của cả bản
 * copy, tức không tách được.
 *
 * Mọi chuỗi trích từ thuộc tính `data-en` của bản thiết kế, trừ `seo.home` (viết mới).
 */
export const common = {
  brand: {
    name: 'Nexa',
    byline: 'by NewEra Inc.',
    tagline:
      'Channel & topic chat, project management, internal knowledge and AI assistants in one workspace.',
  },

  nav: {
    items: [
      { id: 'modules', label: 'Modules' },
      { id: 'collab', label: 'Collaboration' },
      { id: 'ai', label: 'AI Agents' },
      { id: 'security', label: 'Security' },
      { id: 'pricing', label: 'Pricing' },
      { id: 'faq', label: 'FAQ' },
    ],
    home: 'Home',
    cta: 'Start free trial',
    signIn: 'Sign in',
    skipToContent: 'Skip to main content',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    languageSwitcher: 'Choose language',
    mainNav: 'Main navigation',
    switchTo: {
      vi: 'Switch to Vietnamese',
      en: 'Switch to English',
    },
  },

  seo: {
    home: {
      title: 'Nexa — one workspace, nothing scattered',
      description:
        'Nexa unifies channel & topic chat, project management, internal knowledge and AI assistants in a single workspace. Deploy on cloud or fully on-premise.',
    },
  },

  page: {
    home: {
      heading: 'One workspace. Nothing scattered.',
      body: 'Nexa unifies channel & topic chat, project management, internal knowledge and AI assistants in a single workspace — deployed on cloud or fully on-premise.',
    },
  },

  notFound: {
    title: 'Page not found',
    heading: '404 — This page does not exist',
    body: 'The link may have changed or been mistyped.',
    backHome: 'Back to homepage',
  },
};
